import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  heading: `Welcome to the fourth annual State of Personalization report, our yearly deep-dive into the latest trends in personalization, consumer loyalty, privacy, and more.`,
  description: [
    `Through our extensive survey analysis from business leaders and consumers alike, we’ll take you on a journey through the most significant global trends in 2023. From the latest advancements in AI-powered personalization to the rising importance of consumer privacy, we’ll explore the strategies and tactics businesses are using to connect with their customers on a deeper level.`,
    `Continue reading for selected highlights from our research, or download the full report above.`,
  ],
}

const Introduction = () => {
  return (
    <StyledSectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase>
          <CopyText.Heading variant="h4" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          {copy.description.map((paragraph, index) => (
            <Description key={index} variant="pLarge" tag="p">
              {paragraph}
            </Description>
          ))}
        </CopyTextBase>
      </Section.Copy>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    grid-template-areas: 'copy';
    grid-template-rows: auto;
  }
`

const Description = styled(CopyText.Description)`
  margin-top: 32px;
`

export default Introduction
